import { DateConstants } from "lookup/DateConstants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { formatDateForDisplay } from "services/MomentUtils";
import { isCollectionNullOrEmpty } from "services/UtilityService";

export const renderDateCell = (date) => {
  return (
    <span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      {date}
    </span>
  );
};

export const renderScheduledDateCell = (date, status) => {
  return (
    <span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <span style={{ color: DateConstants.statusColors[status] }}>
        &#x25cf; &nbsp;
      </span>
      {date}
    </span>
  );
};

export const renderNotesCell = (description) => {
  let displayDescription = description;
  if (description && description.length > 60) {
    displayDescription = description.substring(0, 60) + "...";
    return (
      <OverlayTrigger overlay={<Tooltip className="custom-tooltip">{description}</Tooltip>}>
        <span>
          {displayDescription}
        </span>
      </OverlayTrigger>
    );
  }
  return (
    <span>
      {displayDescription}
    </span>
  );
};

export const renderAllSwitchesCell = (aggregatedSwitchesStr) => {
  let dispSwitches = aggregatedSwitchesStr;
  if (aggregatedSwitchesStr && aggregatedSwitchesStr.length > 12) {
    dispSwitches = aggregatedSwitchesStr.substring(0, 12) + "...";
    return (
      <OverlayTrigger overlay={<Tooltip>{aggregatedSwitchesStr}</Tooltip>}>
        <span
          style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          {" "}{dispSwitches}{" "}
        </span>
      </OverlayTrigger>
    );
  }
  return (
    <span style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      {" "}
      {dispSwitches}{" "}
    </span>
  );
};

export const renderScheduledDateCol = (date, days) => {
  if (date) {
    const status = days >= 0 ? "ComingDue" : "PastDue";
    return renderScheduledDateCell(formatDateForDisplay(date), status);
  } else {
    return null;
  }
};

export const renderGeneratedDateCol = (date) => {
  if (date) {
    return renderDateCell(formatDateForDisplay(date));
  }
  return <span className="center">N/A</span>;
};

export const renderAWStatusFilterValue = (filter, row) => {
  const filterObj = filter?.filter((e) => e.id === "status")[0];
  const filterValue = !filterObj ? null : filterObj.value;
  
  // When no filter is selected (null, empty array, or multiple values)
  if (filterValue === null || (Array.isArray(filterValue) && (isCollectionNullOrEmpty(filterValue) || filterValue.length > 1))){
    // Check hasNewActivity first (computed from backend when at least one activity is NEW)
    if (row.original.hasNewActivity) {
      return 'NEW';
    }
    return row.original.status;
  }
  else if(filterValue[0] === 'ALL' || filterValue === 'ALL'){
    return row.original.hasNewActivity ? 'NEW' : row.original.containsEscalatedActivities ? 'ESCALATED' : row.original.containsHeldActivities ? 'ON_HOLD' : row.original.status;
  }
  else {
    return filterValue;
  }
}

